import {mapToFlatListWithKey, WithChildren} from '@hconnect/common/utils'

export const tableCellDataTestIdGenerator = (id: string, columnKey: string) =>
  `table-cell-${id}-${columnKey}`

export const getAllItemIds = <K extends keyof T, T extends WithChildren<T, K> & {id: string}>(
  childrenKey: K,
  data: T[]
): string[] => {
  return mapToFlatListWithKey(childrenKey, data ?? []).map((entry) => entry.id)
}
